export default __webpack_public_path__ + "static/media/poweredByNozl.c35c6092.png";